/** Centralised React Query keys (spec §12.1). */
export const queryKeys = {
  session: ['auth', 'session'] as const,
  providers: (clientId: string | null) => ['auth', 'providers', clientId] as const,
  identities: ['auth', 'identities'] as const,
  me: ['user', 'me'] as const,
};
